import { canFilter } from '../../mixins/can_filter';
import { canPaginate } from '../../mixins/can_paginate';

angular
.module('app.views')
.config(($routeProvider) => {
    $routeProvider.when('/boxcasters', {
        template: require('./boxcasters.html'),
        controller: 'BoxcastersController'
    });
})
.controller('BoxcastersController', function($scope, $location, $modal, Account, Boxcaster, Config, toaster) {
    canFilter($scope, $location);
    canPaginate($scope, $location);
    $scope.s || ($scope.s = 'id');
    $scope.config = Config;
    $scope.loading = true;

    const params = _.pick($scope, 'q', 's', 'p');

    if (params.q && params.q.match(/^[a-zA-Z0-9]+$/)) {
        params.q = `name:*${params.q}* id:*${params.q}*`;
    }

    if ($scope.f.account && $scope.f.account.active) {
        params['filter.account_id'] = $scope.f.account.id;
    }

    if ($scope.f.credentialed && $scope.f.credentialed.active) {
        params['filter.credentialed'] = $scope.f.credentialed.value;
    }

    $scope.boxcasters = Boxcaster.query(params, function(data, getResponseHeader) {
        $scope.loading = false;
        const pagination = getResponseHeader('X-Pagination');
        return $scope.pagination = (pagination ? JSON.parse(pagination) : {});
    });

    $scope.createManufacturingBoxcasters = () => {
        $modal.open({ template: require('./boxcasters_new_mfg_form.html'), controller: 'BoxcastersNewMfgController', size: 'lg', backdrop: 'static' }).result.then(mfgAccountId => {
            Account.get({id: mfgAccountId}, a => {
                const accountFilter = "account:" + encodeURIComponent(JSON.stringify(_.extend({active: true}, _.pick(a, 'id', 'name'))));
                const credentialedFilter = "credentialed:" + encodeURIComponent(JSON.stringify({active: true, value: false}));
                $location.url(`/boxcasters?f=${encodeURIComponent(accountFilter + " " + credentialedFilter)}`);
            }, err => {
                console.error(err);
                toaster.pop({
                    type: 'error',
                    body: `Error loading manufacturing account. Please try again.`,
                    timeout: 2000
                });
            });
        });
    };

    // TODO: replace with filter?
    $scope.getStatusWarning = function(boxcaster) {
        if (boxcaster.status === 'offline') {
            if (Date.now() >= boxcaster.next_broadcast_at) {
                return 'offline (missing_broadcast)';
            } else {
                return 'offline';
            }
        } else if (boxcaster.warning !== 'none') {
            return `${boxcaster.status} (${boxcaster.warning})`;
        } else {
            return boxcaster.status;
        }
    };

    $scope.extraFields = localStorage.getItem('boxcasters.fields');
    if ($scope.extraFields) {
        $scope.extraFields = JSON.parse($scope.extraFields);
    } else {
        $scope.extraFields = {
            last_ip: true,
            last_seen: true,
            payment_status: false,
            physical_status: false
        };
    }

    // Count the number of columns visible
    let baseCount = 4;
    $scope.fieldCount = baseCount + Object.keys($scope.extraFields).filter((key) => $scope.extraFields[key] === true).length;

    return $scope.toggle = function(field, e) {
        $scope.extraFields[field] = !$scope.extraFields[field];
        localStorage.setItem('boxcasters.fields', JSON.stringify($scope.extraFields));
        $scope.fieldCount = baseCount + Object.keys($scope.extraFields).filter((key) => $scope.extraFields[key] === true).length;
        e.preventDefault();
        e.stopPropagation();
        return false;
    };
});


// WEBPACK FOOTER //
// ./views/boxcasters/boxcasters_controller.js